export class Claims {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  idp: string;
  name: string;
  nonce: string;
  oid: string;
  preferred_username: string;
  rh: string;
  sub: string;
  tid: string;
  uti: string;
  ver: string;

  constructor() { }
}

export class IdToken {
  rawIdToken: string;
  claims: Claims;
  issuer: string;
  objectId: string;
  subject: string;
  tenantId: string;
  version: string;
  preferredName: string;
  name: string;
  nonce: string;
  expiration: number;

  constructor() { }
}

export class IdTokenClaims {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  idp: string;
  name: string;
  nonce: string;
  oid: string;
  preferred_username: string;
  rh: string;
  sub: string;
  tid: string;
  uti: string;
  ver: string;

  constructor() { }
}

export class IdToken2 {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  idp: string;
  name: string;
  nonce: string;
  oid: string;
  preferred_username: string;
  rh: string;
  sub: string;
  tid: string;
  uti: string;
  ver: string;

  constructor() { }
}

export class IdTokenClaims2 {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  aio: string;
  idp: string;
  name: string;
  nonce: string;
  oid: string;
  preferred_username: string;
  rh: string;
  sub: string;
  tid: string;
  uti: string;
  ver: string;

  constructor() { }
}

export class Account {
  accountIdentifier: string;
  homeAccountIdentifier: string;
  userName: string;
  name: string;
  idToken: IdToken2;
  idTokenClaims: IdTokenClaims2;
  environment: string;

  constructor() { }
}

export class AzureTokenModel {
  uniqueId: string;
  tenantId: string;
  tokenType: string;
  idToken: IdToken;
  idTokenClaims: IdTokenClaims;
  accessToken: string;
  scopes: string[];
  expiresOn: Date;
  account: Account;
  accountState: string;
  fromCache: boolean;

  constructor() { }
}

export class AzureErrorResponse {
  code: string;
  message: string;
}
